'use strict';

var fitvids = require('fitvids');

module.exports = {
    init: function() {
        document.querySelectorAll('.s-prose .ss-htmleditorfield-file.embed iframe').forEach(el => {
            // Ignore videos that already have the wrapping div.js-fit-video
            if (!el.closest('.js-fit-video')) {
                el.parentElement.style.width = 'unset';
            }
        });

        setTimeout(function () {
            fitvids('.js-fit-video, .content-panel, .page-content, .ss-htmleditorfield-file.embed');
        }, 1000);
    }
};



// WEBPACK FOOTER //
// ./modules/videoResize.js